module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADrSURBVHgB7ZTNDYJAEIXfbiiAEigB+buqHViCVqB2YgfaiXolBCzBDsQ7P75NXGLQixk5kPglZCZvyWN3dhhgbCibpGnqK6VcCInj+NQZZ1m2Y1jjN5yiKJqroijcuq5vFK5GhIwFH1dr7TkmeYpXfmkFATy5xzAzufOi+1zYQwDvyGvbFn1js/MlBFjTvvGFtdlAQNM0pgn8vnEZBMEZAljK0ubOh8UDazV91XjEkhc7wRfovkDT9sN7Jb7kbcdhGIpazqIxEH/jjkF+aca7HZtHPIeHFJru2FnbbtDneT6FkKqq7kmSXDBKHo4pSfh6GdfUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/funds/deposite-amount-icon.png
// module id = P1a0
// module chunks = 0